export enum Categories {
    PRKommunikation = "PR & Kommunikation",
    MarketingOnlineMarketing = "Marketing & Online Marketing",
    InterneKommunikationChangeKommunikation = "Interne Kommunikation & Change Kommunikation",
    IntranetDigitalWorkplace = "Intranet & Digital Workplace",
    ProjektmanagementKundenberatung = "Projektmanagement & Kundenberatung",
    Design = "Design",
    TextRedaktion = "Text & Redaktion"
}